<template>
    <div>
        <v-card>
            <v-card-title>
                <v-icon color="primary">
                    mdi-account-cash-outline
                </v-icon>
                <span class="pl-2 pr-2">{{ $t('transfer_coins') }}</span>
                <info-tool-tip
                    :message="$t('transfer_coins_info')"
                ></info-tool-tip>
            </v-card-title>
            <!-- the page the database sends, not every parent the school has
                 ever had: this screen used to fetch the lot to fill a table -->
            <v-data-table
                :options.sync="tableOptions"
                :footer-props="footerProps"
                :no-data-text="$t('noData')"
                :no-results-text="$t('noResults')"
                item-key="id"
                :loading="isLoading"
                :loading-text="$t('loading_parents')"
                :headers="translatedHeaders"
                :items="parents"
                :server-items-length="total"
            >
                <template v-slot:top>
                    <v-text-field
                        v-model="search"
                        :label="$t('search_parents')"
                        class="mx-4"
                    ></v-text-field>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-btn
                        depressed
                        color="primary"
                        @click="transfer(item)"
                        class="mx-1"
                    >
                        {{ $t('transfer_button') }}
                        <v-icon right dark> mdi-check </v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import InfoToolTip from "@/components/InfoToolTip";
import tableState from "@/mixins/tableState";

export default {
  mixins: [tableState],
    components: {
        InfoToolTip,
    },
    data() {
        return {
            parents: [],
            total: 0,
            isLoading: true,
            tableStateKey: "transfer-coins",
            planDialog: false,
            valid: true,
            id: null,
            planTypeName: "",
            selectedPlan: null,
            headers: [
                { text: "ID", value: "id", align: "start", filterable: false },
                { text: "Email", value: "email" },
                { text: "Name", value: "name" },
                { text: "Balance", value: "balance" },
                { text: "Actions", value: "actions", sortable: false },
            ],
        };
    },
    computed: {
        translatedHeaders() {
            return this.headers.map(header => ({
                ...header,
                text: this.$t(header.text.toLowerCase().replace(' ', '_'))
            }));
        },
    },
    watch: {
        //the page, the size and the search all mean "ask the server again"
        tableOptions: {
            handler() {
                this.loadParents();
            },
            deep: true,
        },
        debouncedSearch() {
            this.loadParents();
        },
    },
    mounted() {
        this.loadParents();
    },
    methods: {
        loadParents() {
            const options = this.tableOptions || {};

            this.isLoading = true;
            axios
                .get('/users/list', {
                    params: {
                        type: 'guardians',
                        page: options.page || 1,
                        per_page: options.itemsPerPage > 0 ? options.itemsPerPage : 25,
                        search: this.debouncedSearch || null,
                        sort_by: (options.sortBy || [])[0] || null,
                        sort_desc: (options.sortDesc || [])[0] ? 1 : 0,
                    },
                })
                .then((response) => {
                    //the endpoint answers with parents and sub-guardians; only
                    //a parent holds a balance to top up
                    this.parents = (response.data.data || []).filter((user) => user.role_id === 4);
                    this.total = response.data.total || this.parents.length;
                })
                .catch((error) => {
                    this.$notify({
                        title: this.$t("error_title"),
                        text: this.$t("error_retrieving_parents"),
                        type: "error",
                    });
                    console.log(error);
                    this.$swal(this.$t("error_title"), error.response.data.message, "error");
                })
                .then(() => {
                    this.isLoading = false;
                });
        },
        transfer(parent) {
            this.$swal
                .fire({
                    title: this.$t("transfer_coins_title"),
                    text: this.$t("enter_coins_amount", { name: parent.name }),
                    input: "number",
                    inputAttributes: {
                        min: 1,
                    },
                    inputValidator: (value) => {
                        if (!value || value <=0) {
                            return this.$t("enter_valid_number");
                        }
                    },
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonText: this.$t("transfer_confirm"),
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        let coins = result.value;
                        this.isLoading = true;
                        axios
                            .post("/users/transfer-coins", {
                                parent_id: parent.id,
                                coins: coins,
                            })
                            .then((response) => {
                                this.$notify({
                                    title: this.$t("success_title"),
                                    text: this.$t("coins_transferred_successfully"),
                                    type: "success",
                                });
                                //update parent balance with coins
                                let index = this.parents.findIndex((p) => p.id === parent.id);
                                this.parents[index].balance = Number(this.parents[index].balance) + Number(coins);
                            })
                            .catch((error) => {
                                this.$notify({
                                    title: this.$t("error_title"),
                                    text: this.$t("error_transferring_coins"),
                                    type: "error",
                                });
                                console.log(error);
                                this.$swal(this.$t("error_title"), error.response.data.message, "error");
                            })
                            .then(() => {
                                this.isLoading = false;
                            });
                    }
                });
        },
    },
};
</script>
